<template lang="pug">
#central-alertas(v-loading='carregando', style='height: 100%')
    h3 {{ $t('mensagens.home.centralAlertas.titulo') }}
    .lyra__cartao(:style='{ pointerEvents: usuarioIsLaudo ? "none" : "auto" }')
        el-tabs.central-alertas__space(v-model='active', stretch)
            el-tab-pane(
                v-for='total in totalizadores',
                :key='total.name',
                :label='total.nome',
                :name='total.periodo'
            )
                .central-alertas__master(:class="(ambientePy || ambienteAr) ? 'central-alertas__master__ambientePy' : ''")
                    .central-alertas__lado
                        span.central-alertas__numero
                            | {{ total.socioambiental }}
                        .central-alertas__tipo
                            p {{ $t('mensagens.home.centralAlertas.alertas') }}
                            p {{ $t('mensagens.home.centralAlertas.socioambientais') }}
                    .central-alertas__lado(v-if="!(ambientePy || ambienteAr)")
                        span.central-alertas__numero
                            | {{ total.agricola }}
                        .central-alertas__tipo
                            p {{ $t('mensagens.home.centralAlertas.alertas') }}
                            p {{ $t('mensagens.home.centralAlertas.agricolas') }}

        BaseButton(
            :class='usuarioIsLaudo ? "central-alertas__acesso_btn__is-laudo" : "central-alertas__acesso_btn"'
            :disabled='usuarioIsLaudo',
            @click='abrirModalSelecaoAlertas()'
        ) {{ $t('mensagens.home.centralAlertas.visualizarAlertas') }}
            i.ml-2.el-icon-right.el-icon-right

        el-tooltip(v-if='erroAoBuscar', placement='left', content='Atualizar')
            .central-alertas__erro-carregamento
                i.el-icon-refresh-right(@click='buscarTotalizadores()')
        
    ModalSelecaoTipoAlerta(
        :show='abrirModalSelecaoTipoAlerta',
        width='400px',
        :periodoAlerta='active',
        @closeDialog='abrirModalSelecaoTipoAlerta = false',
        @processar='realizarPreAnaliseCredito(cpfCnpjModalPreAnaliseCredito ? cpfCnpjModalPreAnaliseCredito : filtro)'
    )
        
</template>

<script>
import AlertaService from '@/services/AlertaService';
import ModalSelecaoTipoAlerta from '@/components/home/ModalSelecaoTipoAlerta.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'CentralAlerta',

    components: {
        ModalSelecaoTipoAlerta,
        BaseButton
    },

    mounted() {
        this.buscarTotalizadores();
    },

    watch: {
        '$i18n.locale'(newLocale) {
            this.atualizarNomesFiltros();
        }
    },

    computed: {
        ...mapState(['usuarioIsLaudo', 'usuarioLogado']),
        ...mapGetters(['ambientePy', 'ambienteAr'])
    },

    data() {
        return {
            totalizadores: {},
            active: 'diario',
            carregando: true,
            erroAoBuscar: false,
            abrirModalSelecaoTipoAlerta: false
        };
    },

    methods: {
        async buscarTotalizadores() {
            this.carregando = true;
            await AlertaService.buscarTotalizadores()
                .then(({ data }) => {
                    this.totalizadores = data;
                    this.erroAoBuscar = false;
                    this.atualizarNomesFiltros();
                })
                .catch(() => {
                    this.erroAoBuscar = true;
                    this.totalizadores = [
                        {
                            periodo: 'diario',
                            socioambiental: '--',
                            agricola: '--',
                            nome: this.$t('mensagens.blocoAlerta.filtros.hoje')
                        },
                        {
                            periodo: 'semanal',
                            socioambiental: '--',
                            agricola: '--',
                            nome: this.$t('mensagens.blocoAlerta.filtros.seteDias')
                        },
                        {
                            periodo: 'mensal',
                            socioambiental: '--',
                            agricola: '--',
                            nome: this.$t('mensagens.blocoAlerta.filtros.trintaDias')
                        }
                    ];
                    this.$notify.warning({
                        message: this.$t('mensagens.home.centralAlertas.erro')
                    });
                })
                .finally(() => {
                    this.carregando = false;
                });
        },
        
        atualizarNomesFiltros() {
            this.totalizadores = this.totalizadores.map(totalizador => {
                let chaveTraducao;
                switch (totalizador.periodo) {
                    case 'diario':
                        chaveTraducao = 'hoje';
                        break;
                    case 'semanal':
                        chaveTraducao = 'seteDias';
                        break;
                    case 'mensal':
                        chaveTraducao = 'trintaDias';
                        break;
                    default:
                        chaveTraducao = totalizador.periodo;
                }

                return {
                    ...totalizador,
                    nome: this.$t(`mensagens.blocoAlerta.filtros.${chaveTraducao}`)
                };
            });
        },
        
        abrirModalSelecaoAlertas() {
            this.abrirModalSelecaoTipoAlerta = true;
        }

    }
};
</script>

<style lang="scss" scoped>
.lyra__cartao {
    height: 100%;

    .central-alertas__acesso_btn,
    .central-alertas__acesso_btn__is-laudo {
        background-color: #fbfbfb;
        color: var(--primary);
        width: 100%;
        border: none;
        font-weight: 500;
        border-radius: 0 0 5px 5px;
    }

    .central-alertas__acesso_btn__is-laudo {
        opacity: 0.5;
    }

    .central-alertas__acesso_btn:hover {
        background-color: var(--secondary-two);
        color: white;
    }
}

.central-alertas__erro-carregamento {
    color: var(--primary);
    cursor: pointer;
    position: absolute;
    right: 18px;
    bottom: 10px;
}

.central-alertas__space {
    padding: 0 20px;
    height: 78%;
}

.central-alertas__lado {
    width: 50%;
    height: 70%;
    display: flex;
    flex-direction: row;
    align-items: center;
    min-height: 70px;
    justify-content: center;
}

.central-alertas__master {
    display: flex;
    justify-content: space-between;
    height: 100%;
    min-height: 80px;
}

.central-alertas__master__ambientePy {
    justify-content: center !important;
}

.central-alertas__master:first-child {
    margin-left: 10px;
}

.central-alertas__numero {
    font-size: 45px;
    color: var(--warning);
    font-weight: 500;
    margin-right: 10px;
    word-break: break-all;
    line-height: 45px;
}

.central-alertas__tipo p {
    margin: 0;
}
</style>

<style lang="scss">
#central-alertas {
    position: relative;

    .el-tabs__item {
        color: var(--primary) !important;
    }

    .el-tabs__item.is-active {
        color: var(--primary) !important;
    }

    .el-tabs__active-bar {
        background-color: var(--secondary) !important;
    }

    .el-tabs__nav-wrap:after {
        background-color: var(--white) !important;
    }

    &>h3 {
        font-weight: 700;
        margin-bottom: 5px;
    }
}
</style>
